import React from 'react';
import { getTimeSlots } from '../../api';
import GenericAssigner from './GenericAssigner';

const TimeSlotAssigner = ({
  order,
  onTimeSlotChange,
  multiSelect = false,
  selectedOrderIds = [],
  preChargedTimeSlots
}) => {
  return (
    <GenericAssigner
      order={order}
      onChange={onTimeSlotChange}
      multiSelect={multiSelect}
      selectedOrderIds={selectedOrderIds}
      preChargedOptions={preChargedTimeSlots}
      fetchOptions={getTimeSlots}
      fieldName="timeSlotId"
      displayField="name"
      valueField="valueId"
    />
  );
};

export default TimeSlotAssigner;
